<template>
  <div class="shop-dark-wrapper px-4 px-sm-6 px-md-10">
    <!-- Floating Glassmorphic Header Bar -->
    <v-app-bar flat fixed color="transparent" class="glass-header py-1 px-2 px-sm-4" style="z-index: 100">
      <v-row no-gutters class="align-center justify-space-between width-100">
        <v-col cols="3" class="d-flex justify-start">
          <v-btn class="premium-btn-icon-circle" icon @click="$router.push('/')">
            <v-icon color="white">mdi-chevron-left</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="6" class="d-flex justify-center">
          <v-img
            v-if="false"
            max-height="50px"
            max-width="150px"
            @click="$router.push('/')"
            contain
            src="/img/roodyLogoGreen.png"
            style="cursor: pointer"></v-img>
        </v-col>
        <v-col cols="3" class="d-flex justify-end">
          <v-badge color="#00B074" overlap bordered :value="productsLength" :content="productsLength">
            <v-btn @click="toggleCartVisiblity()" class="premium-btn-icon-circle" icon>
              <v-icon color="white">mdi-cart</v-icon>
            </v-btn>
          </v-badge>
        </v-col>
      </v-row>
    </v-app-bar>

    <!-- Main Title and Subtitle -->
    <div style="margin-top: 110px; padding: 32px 0 16px 0" class="animate-fade-in-up stagger-1">
      <h1 class="premium-title-gradient text-h3 font-weight-black mb-2" style="letter-spacing: -0.04em !important; line-height: 1.15">
        Produkte, die bewegen.
      </h1>
      <p class="text-secondary text-subtitle-1 mb-0" style="max-width: 600px; line-height: 1.5">
        Entdecke exklusive Fitness-Angebote, massgeschneiderte Abonnements und Geschenkgutscheine für dein Wohlbefinden.
      </p>
    </div>

    <!-- Category Filters -->
    <v-row no-gutters class="mb-10 animate-fade-in-up stagger-2">
      <v-chip-group v-model="categorySelection" class="premium-chip-group" mandatory>
        <v-chip value="all">Übersicht</v-chip>
        <v-chip value="abo" class="ml-3">Abonnemente</v-chip>
        <v-chip value="voucher" class="ml-3">Gutscheine</v-chip>
      </v-chip-group>
    </v-row>

    <!-- Loading Indicator -->
    <v-row class="justify-center py-12" v-if="loading">
      <v-progress-circular indeterminate color="#00B074" :size="50" :width="4"></v-progress-circular>
    </v-row>

    <!-- Product Grid -->
    <v-row v-else class="mb-12">
      <v-col cols="12" sm="6" md="4" lg="4" v-for="(product, index) of filteredProducts" :key="'product' + index" class="d-flex">
        <v-card
          @click="openProductPage(product)"
          dark
          flat
          class="glass-card fill-height d-flex flex-column animate-fade-in-up pa-5"
          :class="'stagger-' + ((index % 5) + 1)"
          style="width: 100%">
          <!-- Zoomable Image Container -->
          <div class="image-zoom-container mb-4">
            <v-img aspect-ratio="1.6" class="rounded-xl" :src="'/img/' + product.picture"></v-img>
          </div>

          <!-- Title -->
          <v-card-title class="pt-0 pb-2 px-0 text-h5 font-weight-bold white--text" style="word-break: break-word; line-height: 1.25">
            {{ product.title }}
          </v-card-title>

          <!-- Short Description -->
          <v-card-subtitle
            class="px-0 pb-6 pt-0 grey--text text--lighten-1 flex-grow-1"
            style="word-break: break-word; font-size: 0.95rem; line-height: 1.5">
            {{ product.shortDescription }}
          </v-card-subtitle>

          <!-- Card Footer (Price) -->
          <div class="pt-2 d-flex justify-space-between align-center">
            <div class="price-tag-pill">
              {{ getProductPrice(product.variations) }}
            </div>
            <v-btn
              icon
              color="#00B074"
              class="premium-btn-icon-circle"
              style="background: rgba(0, 176, 116, 0.08) !important; border-color: rgba(0, 176, 116, 0.15) !important">
              <v-icon size="20" color="#00B074">mdi-arrow-right</v-icon>
            </v-btn>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <shop-product-page @close="selectedProduct = null" :product="selectedProduct" v-if="selectedProduct"></shop-product-page>
    <router-view></router-view>
  </div>
</template>

<script>
import api from "../../api"
import shopProductPage from "./shopProductPage.vue"
import { mapGetters, mapActions, mapState } from "vuex"

export default {
  components: { shopProductPage },
  data() {
    return {
      products: [],
      selectedProduct: null,
      categorySelection: "all",
      visibilityToggle: false,
      loading: false, // added default loading indicator state variable to ensure it is defined
    }
  },
  async created() {
    // FIX If we ever Sell
    let art = "well come FIT AG"
    if (window.location.host.includes("winti")) {
      art = "winti FIT AG"
    }

    if (this.user && this.user.studio && this.user.studio.art) {
      art = this.user.studio.art
    }
    this.loading = true

    this.products = await api.fetchProductsPublicStore({ art })
    this.loading = false
    if (this.$route && this.$route.params && this.$route.params.id) {
      this.openProductPage(this.products.find((product) => product._id === this.$route.params.id))
    }
  },
  computed: {
    ...mapState("shopStore", ["openProduct"]),
    ...mapState("userStore", ["user"]),
    ...mapGetters("shopStore", ["productsLength"]),
    filteredProducts() {
      return this.products.filter((product) => this.categorySelection === "all" || product.category === this.categorySelection)
    },
  },
  watch: {
    openProduct(val) {
      this.openProductPage(this.products.find((product) => product._id === val))
    },
  },
  methods: {
    ...mapActions("shopStore", ["toggleCartVisiblity"]),

    openProductPage(product) {
      this.selectedProduct = null
      this.selectedProduct = product
    },
    getProductPrice(variations) {
      if (!variations.length) return "Kein Preis hinterlegt"
      if (variations.length === 1) {
        return variations[0].setOwnPrice ? "Eigene Eingabe" : "CHF " + variations[0].price + ".-"
      } else {
        let prices = variations.map((variation) => variation.price)
        let filteredPrices = prices.filter((price) => price !== "")

        return "Ab CHF " + Math.min(...filteredPrices.map((price) => Number(price))) + ".-"
      }
    },
  },
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap');

.shop-dark-wrapper {
  --bg-primary: #0b0c10;
  --bg-secondary: #1f2833;
  --bg-dark-accent: #0b0c10;
  --bg-card: rgba(255, 255, 255, 0.02);
  --bg-card-hover: rgba(255, 255, 255, 0.04);
  
  --brand-primary: #00B074;
  --brand-primary-glow: rgba(0, 176, 116, 0.35);
  --brand-gradient: linear-gradient(135deg, #00B074 0%, #008758 100%);
  --brand-gradient-hover: linear-gradient(135deg, #05d08b 0%, #00B074 100%);
  
  --border-color: rgba(255, 255, 255, 0.05);
  --border-color-hover: rgba(0, 176, 116, 0.3);
  --border-color-focus: rgba(0, 176, 116, 0.5);
  
  --text-primary: #ffffff;
  --text-secondary: #94a3b8;
  --text-muted: #64748b;
  
  --font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  
  --shadow-premium: 0 25px 50px -12px rgba(0, 0, 0, 0.7);
  --shadow-glow: 0 0 40px rgba(0, 176, 116, 0.12);
  --shadow-glow-hover: 0 0 50px rgba(0, 176, 116, 0.25);
  --blur-amount: 20px;

  background: radial-gradient(circle at 0% 0%, #102019 0%, #08090c 70%) !important;
  color: var(--text-primary) !important;
  min-height: 100vh;
  font-family: var(--font-family) !important;
  letter-spacing: -0.01em;
}

.glass-header {
  background: #0b0c10 !important;
  backdrop-filter: blur(var(--blur-amount)) saturate(180%) !important;
  -webkit-backdrop-filter: blur(var(--blur-amount)) saturate(180%) !important;
  border-bottom: 1px solid var(--border-color) !important;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.4) !important;
  transition: all 0.3s ease;
}

::v-deep .premium-btn-icon-circle {
  background: rgba(255, 255, 255, 0.03) !important;
  border: 1px solid rgba(255, 255, 255, 0.06) !important;
  border-radius: 50% !important;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1) !important;
  box-shadow: none !important;
}

::v-deep .premium-btn-icon-circle:hover {
  background: rgba(255, 255, 255, 0.08) !important;
  border-color: rgba(255, 255, 255, 0.2) !important;
  transform: scale(1.08) translateY(-1px) !important;
}

.premium-title-gradient {
  background: linear-gradient(135deg, #ffffff 40%, #a3e635 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: var(--font-family);
  font-weight: 800 !important;
  letter-spacing: -0.03em;
  text-transform: none !important;
}

::v-deep .premium-chip-group .v-chip {
  background: rgba(255, 255, 255, 0.02) !important;
  color: var(--text-secondary) !important;
  border: 1px solid var(--border-color) !important;
  border-radius: 100px !important;
  font-weight: 600 !important;
  font-size: 0.85rem !important;
  padding: 18px 24px !important;
  letter-spacing: 0.02em !important;
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1) !important;
  text-transform: uppercase;
}

::v-deep .premium-chip-group .v-chip:hover {
  background: rgba(255, 255, 255, 0.05) !important;
  border-color: rgba(255, 255, 255, 0.15) !important;
  color: var(--text-primary) !important;
  transform: translateY(-1px) !important;
}

::v-deep .premium-chip-group .v-chip--active {
  background: rgba(0, 176, 116, 0.12) !important;
  border-color: var(--brand-primary) !important;
  color: var(--brand-primary) !important;
  box-shadow: 0 0 25px rgba(0, 176, 116, 0.25) !important;
  text-shadow: 0 0 10px rgba(0, 176, 116, 0.3) !important;
}

::v-deep .glass-card {
  background: var(--bg-card) !important;
  backdrop-filter: blur(var(--blur-amount)) !important;
  -webkit-backdrop-filter: blur(var(--blur-amount)) !important;
  border: 1px solid var(--border-color) !important;
  border-radius: 28px !important;
  box-shadow: var(--shadow-premium) !important;
  transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1) !important;
}

::v-deep .glass-card:hover {
  background: var(--bg-card-hover) !important;
  border-color: var(--border-color-hover) !important;
  box-shadow: var(--shadow-premium), var(--shadow-glow-hover) !important;
  transform: translateY(-6px) scale(1.01) !important;
}

.image-zoom-container {
  overflow: hidden;
  border-radius: 20px;
  position: relative;
  background: #0f172a;
}

::v-deep .image-zoom-container .v-image {
  transition: transform 0.8s cubic-bezier(0.16, 1, 0.3, 1) !important;
}

::v-deep .glass-card:hover .image-zoom-container .v-image {
  transform: scale(1.05) rotate(0.5deg) !important;
}

.price-tag-pill {
  background: rgba(0, 176, 116, 0.08) !important;
  border: 1px solid rgba(0, 176, 116, 0.25) !important;
  color: #00B074 !important;
  padding: 6px 14px !important;
  border-radius: 100px !important;
  font-weight: 800 !important;
  font-size: 0.95rem !important;
  letter-spacing: -0.01em;
  box-shadow: 0 4px 12px rgba(0, 176, 116, 0.08);
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-in-up {
  opacity: 0;
  animation: fadeInUp 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.stagger-1 { animation-delay: 0.1s; }
.stagger-2 { animation-delay: 0.2s; }
.stagger-3 { animation-delay: 0.3s; }
.stagger-4 { animation-delay: 0.4s; }

::v-deep .v-btn::before {
  background-color: transparent !important;
}
</style>
<style>
/* Override Vuetify toolbar internal heights and alignment */
.glass-header .v-toolbar__content {
  padding: 0 !important;
  width: 100%;
}
</style>
